import axios from "../utils/axios";

function jwtDecode(token) {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(""),
  );
  return JSON.parse(jsonPayload);
}

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  try {
    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;
    return decoded.exp > currentTime;
  } catch {
    return false;
  }
};

export const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("shiftEndTime");
    localStorage.removeItem("shiftStartTime");
    delete axios.defaults.headers.common.Authorization;
  }
};

export const setRefresh = (refreshToken) => {
  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
  } else {
    localStorage.removeItem("refreshToken");
  }
};

export const setLevel = (levelSelected) => {
  if (levelSelected && levelSelected) {
    localStorage.setItem("levelSelected", JSON.stringify(levelSelected));
    localStorage.setItem("levelPopOver", levelSelected.id);
  } else {
    localStorage.removeItem("levelSelected");
  }
};
